(() => {
  if (customElements.get('nc-product-description')) return;
  customElements.define('nc-product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.nc-description__content');
      this.button = this.querySelector('.nc-description__toggle');
      if (!this.content || !this.button || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.links = new Map(Array.from(this.content.querySelectorAll('a[href]'), a => [a, a.getAttribute('tabindex')]));
      this.button.addEventListener('click', () => {
        this.dataset.expanded = String(this.dataset.expanded !== 'true');
        this.update();
      }, { signal });
      this.content.querySelectorAll('img').forEach(img => img.addEventListener('load', () => this.measure(), { signal }));
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (Math.abs(width - (this.lastWidth || 0)) > 1) {
          this.lastWidth = width;
          this.measure();
        }
      });
      this.observer.observe(this.content);
      this.frame = requestAnimationFrame(() => this.measure());
      document.fonts?.ready.then(() => this.measure());
    }
    measure() {
      if (!this.isConnected || !this.content.getClientRects().length) return;
      const wasExpanded = this.dataset.expanded === 'true';
      this.dataset.ready = '';
      this.dataset.expanded = 'false';
      const overflowing = this.content.scrollHeight > this.content.clientHeight + 2;
      this.button.hidden = !overflowing;
      this.dataset.expanded = String(overflowing && wasExpanded);
      this.update();
    }
    update() {
      const expanded = this.dataset.expanded === 'true';
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.textContent = expanded ? '收回產品介紹' : '展開產品介紹';
      const bottom = this.content.getBoundingClientRect().bottom;
      for (const [link, original] of this.links) {
        if (!expanded && link.getBoundingClientRect().bottom > bottom + 1) link.setAttribute('tabindex', '-1');
        else if (original === null) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', original);
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      for (const [link, original] of this.links || []) {
        if (original === null) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', original);
      }
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
